import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useWeekViewStyles = makeStyles((theme: Theme) =>
  createStyles({
    weekContainer: {
      display: 'flex',
      width: '100%',
    },
    dayColumn: {
      flex: 1,
      borderRight: '1px solid #e0e0e0',
      '&:last-child': {
        borderRight: 'none',
      },
    },
  }),
);
